import { Card } from "react-bootstrap";

function MiniBarChart({ title, data = [], color }) {
  if (!data.length) {
    return (
      <div className="text-center text-muted small py-4">
        Tidak ada data
      </div>
    );
  }

  const maxValue = Math.max(...data.map((d) => d.value));

  return (
    <Card className="border-0 shadow-sm h-100">
      <Card.Body className="p-2">
        {/* Header */}
        <div className="d-flex justify-content-center align-items-center mb-2">
          <span
            className="fw-semibold small"
            style={{ color }}
          >
            {title}
          </span>
        </div>

        {/* Bars */}
        <div className="d-flex flex-column gap-1">
          {data.map((item, idx) => (
            <div
              key={idx}
              className="d-flex align-items-center"
            >
              {/* Label */}
              <div
                className="text-truncate small text-muted me-2"
                style={{ width: 90 }}
                title={item.label}
              >
                {item.label}
              </div>

              {/* Bar */}
              <div className="flex-grow-1 me-2">
                <div
                  className="bg-light rounded"
                  style={{ height: 6 }}
                >
                  <div
                    className="rounded"
                    style={{
                      width: `${(item.value / maxValue) * 100}%`,
                      height: 6,
                      backgroundColor: color,
                    }}
                  />
                </div>
              </div>

              {/* Value */}
              <div
                className="small fw-semibold text-end"
                style={{ width: 28 }}
              >
                {item.value}
              </div>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}

export default MiniBarChart;